var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.error || _vm.message || _vm.warning),expression:"error || message || warning"}],staticClass:"alert alert-dismissible mt-1",domProps:{"innerHTML":_vm._s(_vm.error || _vm.message || _vm.warning)}},'div',{ class: _vm.getAlertClass() },false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e3e2d3f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Template/TemplateAlert.vue
// module id = null
// module chunks = 